/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const accountPages = {
    canChangeSubscription: () => import('@/auth/canChangeSubscription'),
    DebugControlsPage: () => import('@/debug/DebugControlsPage'),
    HelpPage: () => import('@/help/HelpPage'),
    SettingsPage: () => import('@/settings/SettingsPage'),
    SubscriptionPage: () => import('@/subscription/SubscriptionPage'),
}
